// ToolTagManagerTool.jsx
//Manages tags golballyy in parent BootstrapStarterBody

import React, { useRef, useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { addItem, editItem, deleteItem } from './FunctionsTagLibraryManager';
import './CSSToolTagManagerTool.css';

const ToolTagManagerTool = ({
    inputValue,
    setInputValue,
    listItems,
    setListItems,
    rows,
    setRows,
    columns,
    onTagCountChange
}) => {






    const initialSizeForEditTagsTextarea = 25;
    const textareaRefs = useRef({});

    // Improved auto-resize function
    const autoResizeTextarea = (textarea) => {
        if (!textarea) return;

        // Reset to minimum height first
        textarea.style.height = initialSizeForEditTagsTextarea + 'px';

        // Only expand if content requires more space
        if (textarea.scrollHeight > initialSizeForEditTagsTextarea) {
            textarea.style.height = textarea.scrollHeight + 'px';
        }
    };

    // Auto-resize all textareas when listItems change
    useEffect(() => {
        // Use setTimeout to ensure DOM is fully rendered
        setTimeout(() => {
            Object.values(textareaRefs.current).forEach(autoResizeTextarea);
        }, 0);
    }, [listItems]);

    // Also run on mount to handle initial content
    useEffect(() => {
        // Delay slightly more on mount to ensure everything is rendered
        setTimeout(() => {
            Object.values(textareaRefs.current).forEach(autoResizeTextarea);
        }, 10);
    }, []);

    const [hoveredItemId, setHoveredItemId] = useState(null);
    const tagLibraryAvailableTagsCounter = listItems.length;



    useEffect(() => {
        if (onTagCountChange) {
            onTagCountChange(tagLibraryAvailableTagsCounter);
        }
    }, [tagLibraryAvailableTagsCounter, onTagCountChange]);



    const trackAppliedTagsByString = (id) => {
        const uniqueId = id.replace('editTagsGloballyTableRowDataDeleteButton', '');
        const textareaId = `editTagsGloballyTableRowDataInputTextarea${uniqueId}`;
        const textareaElem = document.getElementById(textareaId);

        if (textareaElem) {
            console.log(`trackAppliedTagsByString found ${uniqueId}'s display text, it's ${textareaElem.value}`);
        } else {
            console.log(`trackAppliedTagsByString could not find textarea with id ${textareaId}`);
        }

        // Nested function to scan for all elements with id="itemSelectedTrue"
        const scanSelectedItems = () => {
            const selectedItems = document.querySelectorAll('#itemSelectedTrue');
            console.log(`trackAppliedTagsByString found ${selectedItems.length} instances of id="itemSelectedTrue"`);

            let tagsTextCount = 0;

            selectedItems.forEach(item => {
                const innerTag = item.querySelectorAll('#itemSelectedTrueTagsText');
                tagsTextCount += innerTag.length;
            });

            console.log(`trackAppliedTagsByString found ${tagsTextCount} instances of id="itemSelectedTrueTagsText" inside all instances of id="itemSelectedTrue" in the DOM.`);

            // Nested function to match display text

            const scanSelectedItemsMatchText = () => {
                const tagTextElems = document.querySelectorAll('.itemSelectedTrueTags');
                let matchCount = 0;
                const matchedElems = [];

                tagTextElems.forEach(elem => {
                    const displayText = elem.textContent.trim();
                    if (displayText === textareaElem.value.trim()) {
                        matchCount++;
                        matchedElems.push(elem);
                    }
                });

                console.log(`scanSelectedItemsMatchText Found ${matchCount} instances of matching display text "${textareaElem.value}"`);

                // Now click the divs that matched
                const scanSelectedItemsMatchTextClick = () => {
                    matchedElems.forEach(elem => {
                        if (typeof elem.onclick === 'function') {
                            elem.onclick();
                        } else {
                            console.warn('No onclick function found on element:', elem);
                        }
                    });
                };
                scanSelectedItemsMatchTextClick();
            };
            scanSelectedItemsMatchText();
        };

        scanSelectedItems();
    };


    const editTagsGloballyTableBodyImageChanger = () => {
        const tableBody = document.getElementById("editTagsGloballyTableBody");
        const iconImg = document.getElementById("editTagsGloballyTableHeaderCol01TitleBoxIconImg");

        if (!tableBody || !iconImg) return;

        const hasContent = tableBody.children.length > 0;

        const newSrc = hasContent
            ? "/SVGicons/tagwithpencil-black-gold.svg"
            : "/SVGicons/tagwithpencil-black.svg";

        if (iconImg.src !== window.location.origin + newSrc) {
            iconImg.src = newSrc;
        }
    };
    useEffect(() => {
        editTagsGloballyTableBodyImageChanger();
    }, [listItems]);

    return (
        <div id="tagManagerToolContainer" className="">

            <div id="tagLibraryManagerTitleContainer" className="tagLibraryManagerTitleContainer">
                <div
                    id="tagLibraryManagerTitleContainerIconOverlayContainer"
                    className="tagLibraryManagerTitleContainerIconOverlayContainer">
                    <img
                        id="tagLibraryManagerTitleContainerIconOverlayContainerImg"
                        className="tagLibraryManagerTitleContainerIconOverlayContainerImg"
                        src={tagLibraryAvailableTagsCounter > 0 ? "/SVGicons/tag-black-gold.svg" : "/SVGicons/tag-black.svg"}
                        alt=""
                        style={{ width: '30px', height: '30px' }}
                    />

                    <div
                        id="tagLibraryManagerTitleContainerIconOverlayContainerText"
                        className="tagLibraryManagerTitleContainerIconOverlayContainerText"
                    >
                        {tagLibraryAvailableTagsCounter}
                    </div>
                </div>

                <div id="tagLibraryManagerTitleContainerText" className="tagLibraryManagerTitleContainerText">
                    <p>Tag Library Manager</p>
                </div>
            </div>



            <input
                type="text"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                placeholder="New tag name..."
                id="inputNewTagName"
                className="inputNewTagName"
            />

            <div id="buttonSaveTagIconContainer" className="buttonSaveTagIconContainer">
                <Button
                    onClick={() => addItem({ inputValue, setInputValue, setListItems })}
                    variant="success"
                    id="buttonSaveTag"
                    className="buttonSaveTag"
                >
                    <div>
                        <div id="buttonSaveTagIcon" className="buttonSaveTagIcon">
                            <img
                                id="buttonSaveTagIconImg"
                                src="/SVGicons/checkmark-white.svg"
                                alt="Save Tag"
                                style={{ width: '16px', height: '16px' }}
                            />
                        </div>
                        <div className="buttonSaveTagText">
                            <p>SAVE Tag</p>
                        </div>
                    </div>
                </Button>

                <Button
                    onClick={() => console.log("Tag Library:", listItems)}
                    style={{ display: 'none' }}
                >
                    Console Log Tag Library
                </Button>
            </div>


            <table id="editTagsGloballyTable" className="editTagsGloballyTable">
                <thead id="editTagsGloballyTableHeader" className="editTagsGloballyTableHeader">
                    <tr>
                        <th id="editTagsGloballyTableHeaderCol01" className="editTagsGloballyTableHeaderCol01">

                            <div
                                id="editTagsGloballyTableHeaderCol01TitleBox"
                                className="editTagsGloballyTableHeaderCol01TitleBox"
                            >
                                <div
                                    id="editTagsGloballyTableHeaderCol01TitleBoxIcon"
                                    className="editTagsGloballyTableHeaderCol01TitleBoxIcon"
                                >
                                    <img
                                        id="editTagsGloballyTableHeaderCol01TitleBoxIconImg"
                                        src="/SVGicons/tagwithpencil-black.svg"
                                        alt="Save Tag"
                                        style={{ width: '30px', height: '30px' }}
                                    />
                                </div>
                                <div
                                    id="editTagsGloballyTableHeaderCol01TitleBoxText"
                                    className="editTagsGloballyTableHeaderCol01TitleBoxText"
                                >
                                    <p>Edit Tags Globally</p>
                                </div>
                            </div>




                        </th>
                        <th id="editTagsGloballyTableHeaderCol02" className="editTagsGloballyTableHeaderCol02">
                        </th>
                    </tr>
                </thead>

                <tbody id="editTagsGloballyTableBody" className="editTagsGloballyTableBody">
                    {listItems.map(item => (

                        <tr
                            key={item.id}
                            id={`editTagsGloballyTableRow${item.id}`}
                            className="editTagsGloballyTableRow"
                        >
                            {/* Column 1 of 3 */}
                            <td
                                id={`editTagsGloballyTableRowIconPencil${item.id}`}
                                className="editTagsGloballyTableRowIconPencil"
                            >
                                <img
                                    id={`editTagsGloballyTableRowDataEditTagNameImg${item.id}`}
                                    className="editTagsGloballyTableRowDataEditTagNameImg"
                                    src="/SVGicons/pencil-black.svg"
                                    alt="Edit Tag Name"
                                    style={{ width: '14px', height: '14px' }}
                                />

                            </td>
                            {/* Column 2 of 3 */}
                            <td
                                id={`editTagsGloballyTableRowData${item.id}`}
                                className="editTagsGloballyTableRowData"
                            >
                                <textarea
                                    id={`editTagsGloballyTableRowDataInputTextarea${item.id}`}
                                    className="editTagsGloballyTableRowDataInputTextarea"
                                    value={item.text}
                                    onChange={(e) => {
                                        editItem({
                                            id: item.id,
                                            newText: e.target.value,
                                            listItems,
                                            setListItems,
                                            rows,
                                            setRows,
                                            columns
                                        });

                                        // Use the improved auto-resize function
                                        autoResizeTextarea(textareaRefs.current[item.id]);
                                    }}
                                    ref={(el) => (textareaRefs.current[item.id] = el)}
                                    style={{
                                        height: initialSizeForEditTagsTextarea,
                                        width: '150px' // ✅ Inline override
                                    }}
                                />
                            </td>
                            {/* Column 3 of 3 */}
                            <td
                                id={`editTagsGloballyTableRowIconDelete${item.id}`}
                                className="editTagsGloballyTableRowIconDelete"
                            >
                                <Button
                                    id={`editTagsGloballyTableRowDataDeleteButton${item.id}`}
                                    className="editTagsGloballyTableRowDataDeleteButton"
                                    onClick={(e) => {
                                        trackAppliedTagsByString(e.currentTarget.id);
                                        deleteItem({ id: item.id, setListItems });
                                    }}
                                    onMouseEnter={() => setHoveredItemId(item.id)}
                                    onMouseLeave={() => setHoveredItemId(null)}
                                >
                                    <img
                                        id={`editTagsGloballyTableRowDataDeleteImg${item.id}`}
                                        className="editTagsGloballyTableRowDataDeleteImg"
                                        src={hoveredItemId === item.id ? '/SVGicons/trash-red.svg' : '/SVGicons/trash-black.svg'}
                                        alt="Save Tag"
                                        style={{ width: '16px', height: '16px' }}
                                    />
                                </Button>


                            </td>
                        </tr>

                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default ToolTagManagerTool;